import {
  APIs,
  API_BASE_URL,
  SERVICEURL,
  SHARED_SERVICEURL,
} from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";
import axios from "axios";

export function _base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}


export const uploadScDicom = async (scImage,imageId) => {
  const formData = new FormData();
  formData.append('imageId', imageId);
  formData.append('scImage', scImage);
      
  try {
    const response = await axios.post(API_BASE_URL+APIs.SC_DICOM_UPLOAD, formData, {
      headers: {
        'Accept': 'application/json, text/plain, */*'
      },
    });

    console.log('Success:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error:', error.response);
    if (error.response.status === 403) {
      window.location.assign('/logout'); 
    }
    return error.response;
  }
};


export const submitStudyClipping = async (studyId,seriesId,imageId,scImage) => {
  const formData = new FormData();
  formData.append('studyId', studyId);
  formData.append('seriesId', seriesId);
  formData.append('imageId',imageId);
  if(scImage != null && scImage != undefined){
    formData.append('scImage', scImage);
  }   
  try {
    const response = await axios.post(API_BASE_URL+APIs.SUBMIT_STUDY_CLIPPING, formData, {
      headers: {
        'Accept': 'application/json, text/plain, */*'
      },
    });

    console.log('Success:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error:', error.response);
    if (error.response.status === 403) {
      window.location.assign('/logout'); 
    }
    return error.response;
  }
};


//GET PRIOR STUDY DATA
export const getPriorStudyData = async (studyId, firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETPRIORSDATA,
      // API_BASE_URL + SERVICEURL + APIs.GETPATIENTDATA,
      {
        data: {
          parentStudyId: studyId,
          studyId: null,
          firmId: firmId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getAdvViewerStatus = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.ADVANCEVIEWERSTATUS,
      {},
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//GET STUDY DAYA
export const getStudyData = async (
  studyId,
  firmId,
  hybridMode,
  advanceViewer
) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      // API_BASE_URL + SERVICEURL + APIs.GETPATIENTDATA,
      {
        data: {
          studyId,
          firmId,
          hybridMode,
          advanceViewer,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

// open-api for studyviewer direct access
export const getStudyDataForContextSwitch = async () => {
  try {
       // Get a specific query parameter
       const queryString = window.location.search;
       const urlParams = new URLSearchParams(queryString);
       const clientId = urlParams.get('clientId');
       const secretKey = urlParams.get('secretKey');
       const studyId = urlParams.get('studyId');
      
       const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETOPENAPISTUDYDATA,
      // API_BASE_URL + SERVICEURL + APIs.GETPATIENTDATA,
      {
        data: {
          clientId: clientId,
          studyId: studyId,
          secretKey: secretKey
        
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//GET STUDY DAYA
export const getMobileStudyData = async (
  studyId,
  firmId,
  hybridMode,
  advanceViewer
) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETMOBILESTUDYDATA,
      // API_BASE_URL + SERVICEURL + APIs.GETPATIENTDATA,
      {
        data: {
          studyId,
          firmId,
          hybridMode,
          advanceViewer,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//GET STUDY DAYA
export const getSharedStudyData = async (token, isActiveData, switchViewer) => {

  try {
    const response = await axios.post(
      API_BASE_URL + SHARED_SERVICEURL + APIs.GETSHAREDSTUDYDATA,
      // API_BASE_URL + SERVICEURL + APIs.GETPATIENTDATA,
      {
        data: {
          token,
          isActiveData,
          switchViewer
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//GET ADVANCE VIEWER URL
export const getAdvanceViewerUrl = async(token, isActiveData) => {
  try {
    const response = await axios.post(
      API_BASE_URL + SHARED_SERVICEURL + APIs.GETSHAREDSTUDYADVACNEVIEWERURL,
      {
        data: {
          token,
          isActiveData
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//DOWNLOAD STUDY
export const downloadStudyZip = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADSTUDYZIP,
      {
        data: {
          studyId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//START DOWNLOADING ZIP FILE
export const startDownloadingZip = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.STARTDOWNLOADSTUDYZIP,
      {
        data: {
          studyId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//FETCH PROGRESS OF DOWNLOAD
export const fetchDownloadProgress = async (token) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.FETCHDOWNLOADPROGRESS,
      {
        data: {
          token,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//DOWNLOAD COMPLETED FILE
export const downloadCompletedFile = async (token) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADCOMPLETEDFILE,
      {
        data: {
          token,
        },
      },
      { responseType: "arraybuffer" },
      {
        headers: {
          "content-type": "application/json",
          Accept: "*/*",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//DOWNLOAD PPT
export const downloadStudyPPT = async (studyId, stackId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADSTUDYPPT,
      {
        data: {
          studyId,
          seriesNumber: stackId,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//DOWNLOAD PPT
export const startDownloadingPpt = async (studyId, stackId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADSTUDYPPTASYNC,
      {
        data: {
          studyId,
          seriesNumber: stackId,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const historyDownload = async (body, extension) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.HISTORYDOWNLOAD,
      {
        data: body,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200) {
      if (extension === "doc" || extension === "docx") {
        const fileData = _base64ToArrayBuffer(response.data.data.data);
        const file = new Blob([fileData]);
        const url = window.URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", response.data.data.filename);
        document.body.appendChild(link);
        link.click();
      } else if (extension === "pdf") {
        const fileData = _base64ToArrayBuffer(response.data.data.data);
        const file = new Blob([fileData], {
          type: extension === "pdf" ? "application/pdf" : "text/plain",
        });
        const url = window.URL.createObjectURL(file);
        window.open(url, "_blank", "width=1000,height=700,location=no");
      } else if (extension === "txt") {
        const base64Text = response.data.data.data;
        const decodedText = atob(base64Text).trim();

        const isHTML =
          decodedText.startsWith("<!DOCTYPE html>") ||
          decodedText.startsWith("<html") ||
          decodedText.includes("<body") ||
          decodedText.includes("<div");

        const w = window.open(
          "",
          "_blank",
          "width=1000,height=700,location=no"
        );
        if (isHTML) {
          // Render HTML content
          w.document.open();
          w.document.write(decodedText);
          w.document.close();
        } else {
          // Show as plain text
          const pre = w.document.createElement("pre");
          pre.textContent = decodedText;
          pre.style.whiteSpace = "pre-wrap";
          pre.style.wordWrap = "break-word";
          w.document.body.appendChild(pre);
        }
      } else {
        const image = new Image();
        image.src = "data:image/jpg;base64," + response.data.data.data;

        const w = window.open(
          "",
          "_blank",
          "width=1000,height=700,location=no"
        );
        const parentDiv = document.createElement("div");
        parentDiv.appendChild(image);
        parentDiv.style.display = "flex";
        parentDiv.style.justifyContent = "center";
        parentDiv.style.alignItems = "center";
        parentDiv.style.height = "100%";

        w.document.write(parentDiv.outerHTML);
      }
    }
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const ReturnStudyApi = async (body) => {
  console.log("payload", body);
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/study/unassignStudy",
      {
        data: {
          unassignStudy: body,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const ReleaseStudyApi = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/study/releaseStudy",
      {
        data: {
          studyId: studyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const logViewOriginalImage = async (studyId) => {
  try {
    await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.LOGVIEWORIGINAL,
      {
        data: {
          studyId,
        },
      }
    );
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const activeRadiologistViewing = async (studyId, active) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.ACTIVERADIOLOGISTVIEWING,
      {
        data: {
          studyId: studyId,
          isRadActive: active,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getAdvKeyImagesAPI = async (studyId) => {
  try {
    const response = await axiosInterceptor.get(
      API_BASE_URL + SERVICEURL + `/study/${studyId}/advviewer/keyimages`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const updateAdvKeyImagesAPI = async (studyId, advKeyImageList) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/study/${studyId}/advviewer/keyimages`,
      {
        data: {
          keyImages: advKeyImageList,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const _getAdvKeyImageForPreview = async (studyId, imageId) => {
  try {
    const response = await axiosInterceptor.get(
      API_BASE_URL +
        SERVICEURL +
        `/study/${studyId}/advviewer/keyimages/${imageId}/rendered`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getClippedKeyImagesAPI = async (studyId) => {
  try {
    const response = await axiosInterceptor.get(
      API_BASE_URL + SERVICEURL + `/${studyId}/clippedviewer/keyimages`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const generateUSGLLMReportGenerator = async (studyId, promptText, clippedKeyImagesData, skipImages) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/${studyId}/clippedImages/usg-llm-report-generator`,
      {
        data: {
          promptText: promptText,
          skiptImages: skipImages,
          clippedKeyImagesData: clippedKeyImagesData
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const updateClippedKeyImagesAPI = async (studyId, advKeyImageList) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/${studyId}/clippedviewer/keyimages`,
      {
        data: {
          keyImages: advKeyImageList,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const _getClippedKeyImageForPreview = async (studyId, imageId) => {
  try {
    const response = await axiosInterceptor.get(
      API_BASE_URL +
        SERVICEURL +
        `/${studyId}/clippedviewer/keyimages/${imageId}/rendered`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyExpirationStatus = async (studyId) => {
  console.log("studyId", studyId);
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/unassignment/study/expiration/status/${studyId}`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const extendStudyExpiration = async (studyId) => {
  console.log("studyId", studyId);
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/unassignment/study/extend/expiration/${studyId}`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const forceReinferenceImage = async (studyId, imageId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/image/retriage",
      { data: { studyId, imageId } }
    );
    return response;
  } catch (error) {
    return error.response;
  }
};

export const saveMaskingProfileData = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.SAVEMASKINGPROFILE,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const applyMaskingProfileData = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.APPLYMASKINGPROFILE,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteMaskingProfile = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.DELETEMASKINGPROFILE,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const setDefaultMaskingProfile = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.SETDEFAULTMASKINGPROFILE,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
